import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/upload-ava.png'


const _withScopeId = n => (_pushScopeId("data-v-de30d4fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_tips" }, " 编辑账号信息 ", -1))
const _hoisted_3 = { class: "account-base" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "upload-ava",
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = { class: "info_bg" }
const _hoisted_7 = { class: "line" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "姓名", -1))
const _hoisted_9 = { class: "user_name_bg" }
const _hoisted_10 = { class: "line phone_number_company_info_bg" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "电话", -1))
const _hoisted_12 = { class: "line phone_number_company_info_bg" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "公司", -1))
const _hoisted_14 = { class: "action_button_bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_upload, {
        class: "upload_bg",
        accept: "image/png,image/jpeg",
        "on-error": _ctx.handleError,
        "on-success": _ctx.handleSuccess,
        "http-request": (item) => _ctx.uploadImg(item.file),
        "before-upload": _ctx.beforeUPload,
        "show-file-list": false
      }, {
        default: _withCtx(() => [
          (_ctx.userInfo.headImg)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userInfo.headImg,
                alt: ""
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        _: 1
      }, 8, ["on-error", "on-success", "http-request", "before-upload"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.userInfo.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userInfo.name) = $event)),
              type: "text",
              placeholder: "请输入姓名"
            }, null, 8, ["modelValue"]),
            (_ctx.userLevel == 4)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['user_name_type', _ctx.isEnterpriseAdmin ? 'user_name_type_admin' : ''])
                }, _toDisplayString(_ctx.isEnterpriseAdmin ? '超管' : '普管'), 3))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_el_input, {
            modelValue: _ctx.userShowPhone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userShowPhone) = $event)),
            placeholder: "请输入手机号",
            disabled: "true"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_el_input, {
            modelValue: _ctx.userCompany,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userCompany) = $event)),
            placeholder: "请输入公司名称",
            disabled: "true"
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelButtonClick && _ctx.cancelButtonClick(...args)))
      }, "取消"),
      _createElementVNode("div", {
        class: "btn btn-confirm",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sureButtonClick && _ctx.sureButtonClick(...args)))
      }, "确认更改")
    ])
  ]))
}